'use strict';
const angular = require('angular');

export class detailListModalComponent {
  /*@ngInject*/
  constructor() {
    this.disabled = false;
  }

  $onInit = function () {
    this.config = this.resolve.config;
    this.title = this.config.title || 'Information';
    this.icon = this.config.icon;

    this.data = this.config.data;
    let fields = [];

    this.config.itemData.forEach((dataIdx, idx) => {
      fields.push({
        name: this.config.items[idx],
        data: this.data[dataIdx]
      });
    });

    this.fields = fields;
  };

  ok() {
    this.close({});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduApp.detailListModal', [])
  .component('detailListModal', {
    template: require('./detail-list-modal.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: detailListModalComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/components/detail-list-modal/detail-list-modal.component.js